
import { defineComponent } from "vue";
export default defineComponent({
  created() {
    this.$store.dispatch("fetchHeroData");
  },
  computed: {
    hero() {
      return this.$store.state.hero;
    },
    api() {
      return process.env.VUE_APP_API_URL;
    }
  }
});
